module.exports = __webpack_public_path__ + "static/media/sam.fba6f530.jpg";